// Public API for the WordPress HTML parser renderers/options.
// Consumers import from '@/components/blog-shared/html-parser' — this barrel
// keeps that path stable while the implementation is split across:
//   types.ts           — shared data contracts (CtaContent)
//   renderers.tsx      — CtaCard, the one reusable UI component
//   parser-options.tsx — html-react-parser option builders (detection, extraction,
//                        and their one-off inline markup)

export type {CtaContent} from './types';
export {CtaCard} from './renderers';
export {
    replaceContentImage,
    makeCtaBlocksParseOptions,
    makeCtaBlockParseOptions,
    makeRelatedCardParseOptions,
    makeReadMoreParseOptions,
    newsTableOptions
} from './parser-options';
